define("shared/helpers/remainder", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.remainder = remainder;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Returns the remainder of a two numbers division
   *
   * @method remainder
   * @param {Number} dividend The number that will be divided
   * @param {Number} divisor The number of times the dividend will be divided by
   *
   * @return {Number} Remainder
   */
  function remainder(_ref) {
    let [dividend, divisor] = _ref;
    return dividend % divisor;
  }
  var _default = _exports.default = _helper.default.helper(remainder);
});